import Vue from 'vue'
import App from './App.vue';
import router from './router'
import store from './store/index.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import BindEvent from '@/script/bindevent';
import Call from '@/script/call';
import Utils from '@/script/store';
import Api from '@/script/api';
import Clipboard from 'v-clipboard';
import customMessage from '@/script/Message.js';
import { installDialogPopupZIndexFix, withDialogOverlayZIndex } from '@/script/dialogZIndex.js';
import updateload from "@/components/updateload.vue"
import YQrcode from "@/components/qrcode/qrcode.js";
import mywebviewnowin from "@/components/mywebviewnowin.vue"

Vue.config.productionTip = false
Vue.use(ElementUI);
installDialogPopupZIndexFix();

const originalConfirm = Vue.prototype.$confirm;
Vue.prototype.$confirm = function (message, title, options) {
    if (typeof title === 'object') {
        return originalConfirm.call(this, message, withDialogOverlayZIndex(title));
    }
    return originalConfirm.call(this, message, title, withDialogOverlayZIndex(options || {}));
};

Vue.use(Clipboard);
Vue.use(YQrcode);
// BindEvent.run();

import HoverImg from './directives/hoverImgV2.js'
Vue.directive('hover-img', HoverImg)

// 添加虚拟列表插件（installComponents: false 避免与下面手动注册重复；提高 itemsLimit 防止异常布局时误抛错）
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueVirtualScroller, { RecycleScroller } from 'vue-virtual-scroller'
Vue.use(VueVirtualScroller, { installComponents: false, itemsLimit: 20000 })
Vue.component('RecycleScroller', RecycleScroller)
Vue.component('updateload', updateload);
Vue.component('mywebviewnowin', mywebviewnowin);

Vue.prototype.$call = Call;
Vue.prototype.$api = Api;
Vue.prototype.$utils = Utils;
Vue.prototype.$message = customMessage

window.vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
